import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

/** Short value (e.g. a percentage) inside a 40px brand-colored ring. */
export const CircledLabel = styled(Typography)(({ theme }) => ({
  width: 40,
  height: 40,
  padding: theme.spacing(0.5),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  border: `2px solid ${theme.palette.primary.main}`,
  borderRadius: '50%',
  color: theme.palette.primary.main,
  fontWeight: theme.typography.fontWeightBold,
}));
